<template>
  <div class="animated fadeIn">
    <div v-if="isContentPage" class="card">
      <div class="card-header">
        List of available content
      </div>

      <div class="card-block">
        <div class="list-group">
          <router-link
            v-for="type in contentTypes.children"
            :key="type.name"
            :to="type.url"
            class="list-group-item list-group-item-action"
          >
            <i :class="type.icon" /> {{ type.name }}
          </router-link>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { contentTypes } from '../../helpers/menu';

export default {
  name: 'AppContent',

  data: () => ({
    contentTypes,
  }),

  computed: {
    isContentPage() {
      return this.$route.path === '/admin/content';
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?4a13e630